import styles from "./ProcessSection.module.css"

export default function ProcessSection() {

  return(
    <div className={styles.mainContainer}>
        <p className={styles.mainContainer__title}>Процесс выкупа авто</p>
      <div className={styles.grid}>
        <div className={styles.grid__cell}>
          <div className={styles.grid__cellTitleContainer}>
            <p className={styles.grid__cellNum}>1</p>
            <p className={styles.grid__cellTitle}>Онлайн оценка</p>
          </div>
          <p className={styles.grid__cellText}>В течении 10 минут оценим ваш авто онлайн. Это быстро, удобно и совершенно бесплатно. Всё, что от вас потребуется, — это указать номер свидетельства о регистрации транспортного средства (СТС) и паспорта транспортного средства (ПТС).

Наши специалисты оперативно обработают ваши данные и предоставят точную оценку, основанную на актуальных рыночных ценах. Экономьте своё время и получайте честную и выгодную оценку автомобиля, не выходя из дома!

Попробуйте уже сейчас — процесс займёт всего пару минут, а результат приятно вас удивит!</p>
        </div>
        <div className={styles.grid__cell}>
          <div className={styles.grid__cellTitleContainer}>
            <p className={styles.grid__cellNum}>2</p>
            <p className={styles.grid__cellTitle}>Договариваемся о встрече</p>
          </div>
          <p className={styles.grid__cellText}>Договоримся с вами о встрече, в любом удобном для вас времени и месте. Независимо от вашего графика, мы готовы подстроиться под ваши предпочтения, чтобы процесс был максимально комфортным для вас.

Наша задача — сделать всё, чтобы вам было удобно! Просто сообщите нам, когда и где вам будет удобнее встретиться, и мы организуем встречу с учётом всех ваших пожеланий.

Ваш комфорт для нас в приоритете!</p>
        </div>
        <div className={styles.grid__cell}>
          <div className={styles.grid__cellTitleContainer}>
            <p className={styles.grid__cellNum}>3</p>
            <p className={styles.grid__cellTitle}>Осматриваем ваш авто</p>
          </div>
          <p className={styles.grid__cellText}>На месте осмотрим ваш автомобиль и дадим окончательную оценку. Это позволит нам точно определить его стоимость и предложить вам справедливую и окончательную оценку.

Мы подходим к процессу оценки максимально честно и прозрачно, чтобы вы остались довольны результатом. Всего несколько минут — и вы получите итоговую стоимость вашего авто без лишних ожиданий и скрытых условий.</p>
        </div>
        <div className={styles.grid__cell}>
          <div className={styles.grid__cellTitleContainer}>
            <p className={styles.grid__cellNum}>4</p>
            <p className={styles.grid__cellTitle}>Составляем договор на месте</p>
          </div>
          <p className={styles.grid__cellText}>Нужны лишь документы собственника и все документы на автомобиль.  Никаких лишних требований или сложностей — всё максимально просто и понятно!</p>
        </div>
        <div className={styles.grid__cell}>
          <div className={styles.grid__cellTitleContainer}>
            <p className={styles.grid__cellNum}>5</p>
            <p className={styles.grid__cellTitle}>Подписываем договор и акт<br />приема-передачи транспортного средства</p>
          </div>
          <p className={styles.grid__cellText}>В нашем договоре будут чётко прописаны все ключевые моменты сделки. Мы укажем полную стоимость вашего автомобиля, чтобы вы были уверены в прозрачности сделки. Также в документе будут зафиксированы реквизиты сторон, условия выкупа автомобиля и номер банковского счета, на который будет произведён платёж.

Мы уделяем особое внимание деталям, чтобы вы чувствовали себя уверенно и защищённо на каждом этапе сделки.</p>
        </div>
        <div className={styles.grid__cell}>
          <div className={styles.grid__cellTitleContainer}>
            <p className={styles.grid__cellNum}>6</p>
            <p className={styles.grid__cellTitle}>Переводим вам деньги</p>
          </div>
          <p className={styles.grid__cellText}>После заключения договора средства будут перечислены на ваш банковский счёт, указанный в документе. Вы можете использовать счёт в любом банке — для нас это не имеет значения.

Для вашего спокойствия и уверенности мы предоставим подтверждающий документ о совершении платежа.</p>
        </div>
      </div>
    </div>
  )
}